<template lang="pug">
.step_line_item.d-flex.flex-row.flex-md-column.align-items-md-center
  img.d-none.d-md-block(:src="icon")
  .lines.d-flex.flex-column.flex-md-row.align-items-center.justify-content-center.i_mt_6.i_mt_sm_0.flex-grow-1.flex-md-grow-0
    .line.line_left.flex-grow-0.flex-md-grow-1
    .dot.flex-grow-0
    .line.line_right.flex-grow-1.flex-md-grow-1
  .infos.w-100.d-flex.flex-column.align-items-md-center.i_mt_4.i_mt_sm_0.flex-grow-1.flex-md-grow-0
    .title.w-100.d-flex.align-items-center
      img.d-md-none(:src="icon")
      h5.i_ml_sm_5.text-center {{ title }}
</template>

<script>
export default {
  name: "StepLineItem",
  components: {},
  props: {
    title: String,
    icon: String,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/step_line_item";
</style>
